module.exports = __webpack_public_path__ + "static/00062.e5ae5acb.jpg";